<template lang="pug">
extends ../Base/Card.pug

block card-header
    //- small, this is on News slide cards
    div.card-header-title
        h2.title(v-if="title") {{ title }}
    div.ingress-text(v-if="ingressText" v-html="ingressText")
    div.details(
        v-if="(showAuthor && author) || publishDate")
        div.author(v-if="showAuthor && author") {{ author }}
        em.publish-date {{ publishDate }}


block card-contents
    //- hero size, on Articles index
    router-link.card-hero.card-link(
        v-if="item && hero"
        v-bind:to="linkTo && getMyRoute(item) || '#'"
        v-bind:event="''"
        v-bind:title="getTitle(item)"
        v-on:click.native.prevent="onClick(item, $event)")

        div.article-ingress
            em.publish-date {{ publishDate }}
            b.author(v-if="author") {{ author }}
            h2.title(v-if="title") {{ title }}
            div.ingress-text(v-if="ingressText")
                article(v-html="ingressText")

            div.btn
                router-link(v-bind:to="getRoute(item, null, 'FeatureArticle')")
                    div {{ $t('articles.readThis') }}

</template>

<script>
import BaseCard from '@/components/Base/Card.vue';
import ArticlesMixin from '@/components/Base/ArticlesMixin.js';

export default {
    name: 'feature-article-card',

    extends: BaseCard,

    props: {
        hero: {             type: Boolean },
        className: {        type: String, default: 'feature-article-card article-card' },
        useCoverImage: {    type: Boolean, default: true },
        usePalette: {       type: Boolean, default: true },
        resolution: {       type: Object, default: () => { return {x: '50vw'}; }},
        showAuthor: {       type: Boolean }
    },

    mixins: [ ArticlesMixin ],

    computed: {
        author: function () {
            return this.getArticleAuthor(this.item);
        },

        publishDate: function () {
            return this.getArticlePublishDateString(this.item);
        },

        ingressText: function () {
            return this.getIngressText(this.item);
        },

        ingressImageSrc: function () {
            return this.getArticleIngressImageSrc(this.item, this.resolution);
        },

        imageOrientation: function () {
            return this.$helpers.getImageOrientation(this.item, this.resolution);
        },

        imageResolution: function () {
            //     const ratio = this.$helpers.getImageAspectRatio(this.item);
            //     const x = _.clamp(imageInfo.Width, 400, 700);
            //     let resolution = {x};
            //     if (ratio > 1.5) { // landscape
            //         resolution.y = _.floor(x / ratio);
            //     }
            //     return resolution;
            return this.resolution;
        }
    },

    data: function () {
        return {
            resource: 'featurearticles'
        };
    },

    methods: {
        getCardRoute: function (item) {
            return this.getRoute(item, null, 'FeatureArticle');
        },

        getCardImageSrc: function (item, imageAttrs) {
            return this.ingressImageSrc;
        }
    }
};
</script>

<style scoped lang="scss">
// @import '~assets/styles/mixins';

.feature-article-card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-content: baseline;
    align-self: flex-start;
    justify-content: center;
    margin-top: 0;
    background: $light-gray;
    .card-header {
        z-index: 200;
        width: auto;
        margin: 9px 0 0 0.5rem;
        padding: 0.5rem 1rem;
        color: $dark-gray;
        background: $light-gray;
        border-left: 3px solid black;
        header.tile {
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0 1rem 1rem 0 !important;
            font-size: 1rem;
        }
    }
    .card-header-title {
        display: inline-block;
        width: auto;
        height: auto;
        min-width: unset;
        margin: 0;
        padding: 0;
        // @include fonts-debug(true, true);
        font-family: "Sabon LT W01 Regular", serif;
        color: inherit;
        text-align: left;
        h2.title {
            margin-bottom: 1rem;
            font-family: $article-title-font-sans-serif;
            font-size: 1.25rem;
            line-height: normal;
            letter-spacing: 0;
            color: inherit;
            @include dowrap;
        }
    }
    .ingress-text {
        height: auto;
        // min-height: 80px;
        // max-height: 180px;
        font-family: $helvetica-roman;
        font-weight: 400;
        // white-space: normal;
    }
    .details {
        margin: 1rem 0 0.5rem;
        font-family: "Sabon LT W01 Regular", serif;
    }
    .card-image {
        z-index: 100;
        align-self: stretch;
        width: 100%;
        height: inherit;
        min-height: fit-content;
        background-size: cover;
        background-position-x: 50%;
    }
    .card-contents {
        display: inline-flex;
        flex-direction: column;
        flex-grow: 1;
        align-self: left;
        width: 50%;
        margin-left: 2rem !important;
        padding: 0.5rem 2rem;
        background: rgba(255, 251, 251, 0.65);
        @media screen and (max-width: $breakpoint-tablet - 1) {
            width: auto;
        }
    }
    .card-hero {
        .article-ingress {
            max-width: 32rem;
            font-family: $helvetica-roman;
            word-break: initial;
            em {
                display: block;
                font-family: $helvetica-italic;
                font-style: normal;
                font-size: 1rem;
            }
            b {
                font-weight: normal;
                font-size: 1.125rem;
            }
            h2 {
                margin: 1rem 0;
                // @include fonts-debug(true, false);
                font-family: $article-title-font-sans-serif;
                font-weight: normal;
                font-size: 2.5rem;
                line-height: normal;
                word-break: initial;
                @media (max-height: 500px) {
                    font-size: 1.5rem;
                }
            }
            .ingress-text {
                height: auto;
                font-size: 1.15rem;
            }
            .btn {
                margin: 2rem auto 1rem 0;
                padding: 0.625rem;
                border: 1px solid black;
            }
        }
    }
}
</style>
